import Home from './views/Home.vue'

import Single from './views/Single.vue'
import Project from './views/Project.vue'
import Projects from './views/Projects.vue'
import Random from './views/Random.vue'
import ReviewableShare from './views/ReviewableShare.vue'
import ShareReview from './views/ShareReview.vue'
import ShareViewAll from './views/ShareViewAll.vue'
import Scene from './views/Scene.vue'
import ScenesViewAll from './views/ScenesViewAll.vue'
import Login from './views/Login.vue'
import UserSettings from './views/UserSettings.vue'
import UserAuthToken from './views/UserAuthToken.vue'

import NotFound from './views/NotFound.vue'


export const routes = [

    // root
    { path: '/', component: Home, name: 'home' },

    { path: '/login',  component: Login, name: 'login', meta: { skip_auth: true }},
    { path: '/projects', component: Projects, name: 'projects'},
    { path: '/scenes', component: ScenesViewAll, name: 'scenes' },
    { path: '/scene/:id', component: Scene, name: 'scene' },
    { path: '/shares', component: ShareViewAll, name: 'shares' },
    { path: '/usersettings', component: UserSettings, name: 'usersettings' },
    { path: '/user', component: UserSettings, name: 'usersettings' },
    { path: '/user/authtoken', component: UserAuthToken, name: 'user-authtoken' },
    
    // share-review for notes
    { path: '/share-review/:id', component: ShareReview, name: 'share-review' },
    
    // reviewables
    { path: '/project/:project', component: Project, name: 'project' },
    { path: '/project/:project/shot/:shot', component: Project, name: 'shot' },
    { path: '/single/:id', component: Single, name: 'single' },
    { path: '/random/', component: Random, name: 'random' },

    // exclude from routeguard auth check
    { path: '/share/:uuid', component: ReviewableShare, name: 'share', meta: { skip_auth: true } },

    // 404
    { path: '/404', component: NotFound, name: '404', meta: { skip_auth: true }},
    { path: '*', redirect: '/404' }
]
